// app/translate/translate.service.ts

import {Injectable, Inject} from '@angular/core';
import { TRANSLATIONS, dictionary} from './translations'; // import our opaque token

@Injectable()
export class TranslateServiceForm {
    private _currentLang: string;
    private _DEFAULT_LANG = "ko";


    // inject our translations
    constructor(@Inject(TRANSLATIONS) private _translations: any) {

    }

    public get currentLang() {
        return this._currentLang;
    }

    private getLang(navLang:String): string {
        var langs:string[] = ["ko", "en"];
        for(let lang of langs) {
            if(navLang.indexOf(lang) === 0) {
                return lang;
            }
        }
        return this._DEFAULT_LANG;
    }
    

    public use(lang: string): void {
        // set current language

        this._currentLang = this.getLang(lang);
    }

    private translate(key: string): string {
        // private perform translation
        let translation = key;

        if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
            return this._translations[this.currentLang][key];
        } else {
            return "NONE";
        }
    }

    public instant(key: string, words?: string | string[]) {
        const translation: string = this.translate(key);
        if (!words) return translation;
        return this.replace(translation, words); // call replace function
    }

    private PLACEHOLDER1 = "{"; // our placeholder
    private PLACEHOLDER2 = "}";

    public replace(word: string = '', words: string | string[] = '') {
        let translation: string = word;

        const values: string[] = [].concat(words);
        values.forEach((e, i) => {
            var holder = this.PLACEHOLDER1 + (<any>i) + this.PLACEHOLDER2;
            translation = translation.replace(holder, e);
        });

        return translation;
    }

}


// WEBPACK FOOTER //
// ./src/app/translate/translate.service.ts